import { render, staticRenderFns } from "./DetailReservation.vue?vue&type=template&id=3e0f65f8&scoped=true&"
import script from "./DetailReservation.vue?vue&type=script&lang=js&"
export * from "./DetailReservation.vue?vue&type=script&lang=js&"
import style0 from "./DetailReservation.vue?vue&type=style&index=0&id=3e0f65f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f65f8",
  null
  
)

export default component.exports